var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 45.25C5.08087 45.25 0.875 49.4559 0.875 54.625C0.875 59.7941 5.08087 64 10.25 64C15.4191 64 19.625 59.7941 19.625 54.625C19.625 49.4559 15.4191 45.25 10.25 45.25ZM10.25 22.625C5.08087 22.625 0.875 26.8309 0.875 32C0.875 37.1691 5.08087 41.375 10.25 41.375C15.4191 41.375 19.625 37.1691 19.625 32C19.625 26.8309 15.4191 22.625 10.25 22.625ZM10.25 18.75C15.4191 18.75 19.625 14.5441 19.625 9.375C19.625 4.20587 15.4191 0 10.25 0C5.08087 0 0.875 4.20587 0.875 9.375C0.875 14.5441 5.08087 18.75 10.25 18.75Z",
    fill: "url(#paint0_linear_8817_404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 30.125C9.2145 30.125 8.375 30.9645 8.375 32C8.375 33.0355 9.2145 33.875 10.25 33.875C11.2855 33.875 12.125 33.0355 12.125 32C12.125 30.9645 11.2855 30.125 10.25 30.125ZM10.25 7.5C9.2145 7.5 8.375 8.3395 8.375 9.375C8.375 10.4105 9.2145 11.25 10.25 11.25C11.2855 11.25 12.125 10.4105 12.125 9.375C12.125 8.3395 11.2855 7.5 10.25 7.5ZM25.25 7.5H55.25C56.2864 7.5 57.125 6.66138 57.125 5.625C57.125 4.58862 56.2864 3.75 55.25 3.75H25.25C24.2136 3.75 23.375 4.58862 23.375 5.625C23.375 6.66138 24.2136 7.5 25.25 7.5ZM25.25 15H47.75C48.7864 15 49.625 14.1614 49.625 13.125C49.625 12.0886 48.7864 11.25 47.75 11.25H25.25C24.2136 11.25 23.375 12.0886 23.375 13.125C23.375 14.1614 24.2136 15 25.25 15ZM55.25 26.375H25.25C24.2136 26.375 23.375 27.2136 23.375 28.25C23.375 29.2864 24.2136 30.125 25.25 30.125H55.25C56.2864 30.125 57.125 29.2864 57.125 28.25C57.125 27.2136 56.2864 26.375 55.25 26.375ZM25.25 37.625H47.75C48.7864 37.625 49.625 36.7864 49.625 35.75C49.625 34.7136 48.7864 33.875 47.75 33.875H25.25C24.2136 33.875 23.375 34.7136 23.375 35.75C23.375 36.7864 24.2136 37.625 25.25 37.625ZM55.25 49H25.25C24.2136 49 23.375 49.8386 23.375 50.875C23.375 51.9114 24.2136 52.75 25.25 52.75H55.25C56.2864 52.75 57.125 51.9114 57.125 50.875C57.125 49.8386 56.2864 49 55.25 49ZM47.75 56.5H25.25C24.2136 56.5 23.375 57.3386 23.375 58.375C23.375 59.4114 24.2136 60.25 25.25 60.25H47.75C48.7864 60.25 49.625 59.4114 49.625 58.375C49.625 57.3386 48.7864 56.5 47.75 56.5Z",
    fill: "url(#paint1_linear_8817_404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8817_404",
    x1: 10.25,
    y1: 64,
    x2: 10.25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8817_404",
    x1: 32.75,
    y1: 60.25,
    x2: 32.75,
    y2: 3.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B794F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBets);
export default __webpack_public_path__ + "static/media/empty-bets.2c3714af3d76577dea0b9b60a515a876.svg";
export { ForwardRef as ReactComponent };